import { render, staticRenderFns } from "./CreateCustomRecipientDlg.vue?vue&type=template&id=7832c50c"
import script from "./CreateCustomRecipientDlg.vue?vue&type=script&lang=js"
export * from "./CreateCustomRecipientDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports